// extracted by mini-css-extract-plugin
export default {"dropInSpotsContainer":"styles_dropInSpotsContainer__yvQjl","genderSpots":"styles_genderSpots__CZqCu"};